/**
 * Validación de Cédula de Identidad uruguaya.
 * (copia del módulo en apps/api/src/utils/cedula-uy.ts — misma lógica)
 *
 * Algoritmo DGI/BPS:
 *   pesos [2,9,8,7,6,3,4] sobre los 7 dígitos del cuerpo, módulo 10.
 */

const WEIGHTS = [2, 9, 8, 7, 6, 3, 4] as const;

export function isValidCedulaUY(raw: string): boolean {
  const digits = raw.replace(/[\s.\-]/g, '');
  if (!/^\d{7,8}$/.test(digits)) return false;
  const verifier = Number(digits[digits.length - 1]);
  const body = digits.slice(0, -1).padStart(7, '0');
  let sum = 0;
  for (let i = 0; i < 7; i++) sum += Number(body[i]) * (WEIGHTS[i] ?? 1);
  return verifier === (10 - (sum % 10)) % 10;
}

export function normalizeCedulaUY(raw: string): string | null {
  const digits = raw.replace(/[\s.\-]/g, '');
  if (!/^\d{7,8}$/.test(digits)) return null;
  return digits.padStart(8, '0');
}

export function formatCedulaUY(normalized: string): string {
  const d = normalized.padStart(8, '0');
  const body = d.slice(0, -1);
  const verifier = d[d.length - 1];
  const formatted = body.length <= 3
    ? body
    : body.length <= 6
      ? `${body.slice(0, -3)}.${body.slice(-3)}`
      : `${body.slice(0, -6)}.${body.slice(-6, -3)}.${body.slice(-3)}`;
  return `${formatted}-${verifier}`;
}
